export type SilhouetteType =
  | 'faja'
  | 'bra'
  | 'board'
  | 'gel'
  | 'mask'
  | 'corset'
  | 'boxer'
  | 'pillow'
  | 'tea'
  | 'soap'
  | 'wrap'
  | 'panty'
  | 'sleeve'

export type ProductImage = {
  view: 'front' | 'back' | 'detail' | 'lifestyle'
  silhouette: SilhouetteType
}

export type Product = {
  ref: string
  slug: string
  category: 'fajas' | 'accesorios'
  subcategory?: string
  name: { es: string; en: string }
  shortDesc: { es: string; en: string }
  longDesc: { es: string; en: string }
  indicatedFor: { es: string[]; en: string[] }
  fabric: { es: string; en: string }
  care: { es: string; en: string }
  sizes: string[]
  price: number
  comparePrice?: number
  images: ProductImage[]
  badge?: 'best-seller' | 'new' | 'post-surgery'
}

export type Kit = {
  ref: string
  slug: string
  name: { es: string; en: string }
  description: { es: string; en: string }
  includedRefs: string[]
  originalPrice: number
  price: number
  savings: number
  badge?: 'best-seller' | 'new' | 'post-surgery'
  images: ProductImage[]
}

const SIZES_FAJA = [
  '3XS',
  '2XS',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  '2XL',
  '3XL',
  '4XL',
]
const SIZES_ONE = ['Único']

const CARE_TEXTILE = {
  es: 'Lavar a mano con jabón delicado en agua fría. Secar a la sombra. No usar secadora ni blanqueador.',
  en: 'Hand wash with delicate soap in cold water. Air dry in shade. Do not machine dry or bleach.',
}

const genImages = (silhouette: SilhouetteType): ProductImage[] => [
  { view: 'front', silhouette },
  { view: 'back', silhouette },
  { view: 'detail', silhouette },
  { view: 'lifestyle', silhouette },
]

export const products: Product[] = [
  {
    ref: '1690',
    slug: 'stage-1-lycra-mangas-brasier',
    category: 'fajas',
    badge: 'post-surgery',
    name: {
      es: 'Stage 1 — Faja Lycra con Mangas y Brasier',
      en: 'Stage 1 — Lycra Garment with Sleeves and Built-in Bra',
    },
    shortDesc: {
      es: 'Compresión moderada para etapa inicial post-cirugía. Brasier integrado, glúteos libres.',
      en: 'Moderate compression for early post-surgery stage. Built-in bra, butt-lifting effect.',
    },
    longDesc: {
      es: 'Diseñada para crear silueta hourglass con compresión en cintura, abdomen y brazos. Brasier integrado para soporte post-quirúrgico. Sin compresión trasera para mejor resultado post-BBL. Tres filas de ganchos para máxima ajustabilidad. Cremallera lateral.',
      en: 'Hourglass design with waist, abdomen, and arm compression. Built-in bra for post-surgical support. No rear compression for best BBL results. Three rows of hooks. Side zipper.',
    },
    indicatedFor: {
      es: ['BBL', 'Lipo 360', 'Lipoescultura de brazos', 'Mamoplastia'],
      en: ['BBL', 'Lipo 360', 'Arm lipo', 'Breast surgery'],
    },
    fabric: { es: 'Lycra de alta calidad', en: 'High-quality Lycra' },
    care: CARE_TEXTILE,
    sizes: SIZES_FAJA,
    price: 150,
    images: genImages('faja'),
  },
  {
    ref: '1691',
    slug: 'stage-2-powernet-3-4-pierna',
    category: 'fajas',
    badge: 'post-surgery',
    name: {
      es: 'Stage 2 — Faja Powernet 3/4 Pierna',
      en: 'Stage 2 — Powernet 3/4 Leg Recovery Garment',
    },
    shortDesc: {
      es: 'Alta compresión Powernet para recuperación intermedia. Soporte post-mama, glúteos libres.',
      en: 'High Powernet compression for intermediate recovery. Post-op breast support, BBL-safe.',
    },
    longDesc: {
      es: 'Tela Powernet de alta compresión que promueve la silueta hourglass. Soporte post-operatorio para senos. Levanta glúteos sin comprimir para mejor resultado post-BBL. Tres niveles de ganchos. Cremallera lateral. Tela transpirable.',
      en: 'High-compression Powernet for hourglass shape. Post-op breast support. Lifts glutes without compression for BBL results. Three levels of hooks. Side zipper. Breathable fabric.',
    },
    indicatedFor: {
      es: ['BBL', 'Lipo 360', 'Abdominoplastia'],
      en: ['BBL', 'Lipo 360', 'Tummy Tuck'],
    },
    fabric: {
      es: 'Powernet de alta compresión',
      en: 'High-compression Powernet',
    },
    care: CARE_TEXTILE,
    sizes: SIZES_FAJA,
    price: 150,
    images: genImages('faja'),
  },
  {
    ref: '1696',
    slug: 'stage-2-powernet-mangas-largas',
    category: 'fajas',
    badge: 'post-surgery',
    name: {
      es: 'Stage 2 — Faja Powernet con Mangas Largas y Brasier',
      en: 'Stage 2 — Powernet with Full Sleeves and Built-in Bra',
    },
    shortDesc: {
      es: 'Cobertura completa con mangas largas para lipo de cuerpo + brazos.',
      en: 'Full coverage with long sleeves for combined body and arm lipo recovery.',
    },
    longDesc: {
      es: 'Versión con mangas completas para recuperación combinada de torso, abdomen y brazos. Powernet de alta compresión. Brasier integrado, glúteos libres. Tres niveles de ganchos. Cremallera lateral.',
      en: 'Full-sleeve version for combined torso, abdomen, and arm recovery. High-compression Powernet. Built-in bra, butt-lifting. Three levels of hooks. Side zipper.',
    },
    indicatedFor: {
      es: ['BBL', 'Lipo 360', 'Lipoescultura de brazos', 'Mamoplastia'],
      en: ['BBL', 'Lipo 360', 'Arm lipo', 'Breast surgery'],
    },
    fabric: {
      es: 'Powernet de alta compresión',
      en: 'High-compression Powernet',
    },
    care: CARE_TEXTILE,
    sizes: SIZES_FAJA,
    price: 150,
    images: genImages('faja'),
  },
  {
    ref: '1697',
    slug: 'stage-3-powernet-hourglass-lycra',
    category: 'fajas',
    badge: 'best-seller',
    name: {
      es: 'Stage 3 — Faja Powernet Hourglass con Forro Lycra',
      en: 'Stage 3 — Powernet Hourglass with Lycra Lining',
    },
    shortDesc: {
      es: 'Compresión máxima con forro interior en Lycra para confort prolongado.',
      en: 'Maximum compression with interior Lycra lining for long-wear comfort.',
    },
    longDesc: {
      es: 'Diseño hourglass con compresión extra en cintura y abdomen. Powernet durable de alta compresión. Forro interior en Lycra para máximo confort. Largo a media pierna. 2 filas de ganchos. Glúteos libres post-BBL. Cremallera perineal.',
      en: 'Hourglass design with extra waist and abdomen compression. Durable high-compression Powernet. Interior Lycra lining for maximum comfort. Mid-thigh length. 2 rows of compression. BBL-safe. Perineal zipper.',
    },
    indicatedFor: {
      es: ['BBL', 'Lipo 360', 'Abdominoplastia', 'Mamoplastia'],
      en: ['BBL', 'Lipo 360', 'Tummy Tuck', 'Breast surgery'],
    },
    fabric: {
      es: 'Powernet con forro Lycra',
      en: 'Powernet with Lycra lining',
    },
    care: CARE_TEXTILE,
    sizes: SIZES_FAJA,
    price: 150,
    images: genImages('faja'),
  },
  {
    ref: '3022',
    slug: 'almohada-bbl',
    category: 'accesorios',
    name: { es: 'Almohada BBL', en: 'BBL Pillow' },
    shortDesc: {
      es: 'Soporte para sentarse después de BBL. Transfiere presión a los muslos.',
      en: 'Recommended for post-BBL seating. Transfers pressure to the thighs.',
    },
    longDesc: {
      es: 'Almohada Brazilian Butt Lift recomendada para sentarse durante la recuperación post-BBL. Espuma firme con balance ideal de comodidad y soporte. Incluye funda y estuche para transporte.',
      en: 'Brazilian Butt Lift Pillow recommended for post-surgical seating. Firm foam with ideal balance of comfort and support. Includes pillow cover and carrying case.',
    },
    indicatedFor: {
      es: ['BBL', 'Transferencia de grasa a glúteos'],
      en: ['BBL', 'Fat transfer to glutes'],
    },
    fabric: {
      es: 'Espuma firme con cubierta lavable',
      en: 'Firm foam with washable cover',
    },
    care: CARE_TEXTILE,
    sizes: SIZES_ONE,
    price: 50,
    images: genImages('pillow'),
  },
  {
    ref: '3042',
    slug: 'cinturon-foam-360',
    category: 'accesorios',
    name: { es: 'Cinturón Foam 360', en: '360 Foam Compression Belt' },
    shortDesc: {
      es: 'Compresión 360° para cuerpo completo y corrección postural post-op.',
      en: '360° full-body compression and post-op posture correction.',
    },
    longDesc: {
      es: 'Compresión 360° para cuerpo completo. Soporte y corrección postural post-operatoria. Tirantes ajustables para compresión y comodidad ideales. Espuma suave pero firme. Se usa sobre la faja principal.',
      en: '360° full-body compression. Post-operative support and posture correction. Adjustable straps for ideal compression. Soft yet supportive foam. Used over the main compression girdle.',
    },
    indicatedFor: {
      es: ['Lipo 360', 'BBL', 'Abdominoplastia'],
      en: ['Lipo 360', 'BBL', 'Tummy Tuck'],
    },
    fabric: {
      es: 'Espuma con cubierta suave + tirantes ajustables',
      en: 'Foam with soft cover + adjustable straps',
    },
    care: CARE_TEXTILE,
    sizes: SIZES_ONE,
    price: 70,
    images: genImages('corset'),
  },
  {
    ref: '3026',
    slug: 'tabla-abdominal',
    category: 'accesorios',
    name: { es: 'Tabla Abdominal', en: 'Abdominal Foam Board' },
    shortDesc: {
      es: 'Minimiza inflamación y previene retención de líquidos durante la recuperación.',
      en: 'Minimizes swelling and prevents fluid retention during recovery.',
    },
    longDesc: {
      es: 'Tabla de espuma curva que se adapta perfectamente al abdomen. Distribuye la compresión de la faja uniformemente. Esencial post-lipo y abdominoplastia.',
      en: 'Curved foam board that fits the abdomen perfectly. Distributes girdle compression evenly. Essential post-lipo and tummy tuck.',
    },
    indicatedFor: {
      es: ['Lipo abdominal', 'Abdominoplastia', 'Lipo 360'],
      en: ['Abdominal lipo', 'Tummy Tuck', 'Lipo 360'],
    },
    fabric: {
      es: 'Espuma de alta densidad con cobertura suave',
      en: 'High-density foam with soft cover',
    },
    care: CARE_TEXTILE,
    sizes: SIZES_ONE,
    price: 35,
    images: genImages('board'),
  },
  {
    ref: '3027',
    slug: 'gel-arnica',
    category: 'accesorios',
    name: { es: 'Gel de Árnica 4oz', en: 'Arnica Gel 4oz' },
    shortDesc: {
      es: 'Alivia dolor muscular, reduce inflamación y acelera recuperación de moretones.',
      en: 'Relieves muscle pain, reduces inflammation, and accelerates bruise recovery.',
    },
    longDesc: {
      es: 'Gel de árnica concentrado para uso post-quirúrgico. Alivia dolores musculares, reduce inflamación, acelera la recuperación de moretones. 114g / 4oz.',
      en: 'Concentrated arnica gel for post-surgical use. Relieves muscle pain, reduces inflammation, accelerates bruise recovery. 114g / 4oz.',
    },
    indicatedFor: {
      es: ['Post-quirúrgico general', 'BBL', 'Lipo 360', 'Abdominoplastia'],
      en: ['General post-surgery', 'BBL', 'Lipo 360', 'Tummy Tuck'],
    },
    fabric: {
      es: 'Gel tópico — uso externo',
      en: 'Topical gel — external use',
    },
    care: CARE_TEXTILE,
    sizes: SIZES_ONE,
    price: 18,
    images: genImages('gel'),
  },
]

// Kits removed from boutique — exported as empty to keep imports stable.
export const kits: Kit[] = []

export const getProductByRef = (ref: string) =>
  products.find((p) => p.ref === ref)
export const getProductBySlug = (slug: string) =>
  products.find((p) => p.slug === slug)
export const getProductsByCategory = (category: string) =>
  products.filter((p) => p.category === category)

// Best sellers — feature REF 1697 first, then the rest of the boutique line
export const getBestSellers = () => {
  const order = ['1697', '1690', '1691', '1696', '3022', '3042', '3026', '3027']
  return order.map((ref) => getProductByRef(ref)).filter(Boolean) as Product[]
}

export const getKitWithProducts = (kit: Kit) => ({
  ...kit,
  products: kit.includedRefs
    .map((ref) => getProductByRef(ref))
    .filter(Boolean) as Product[],
})
